//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiChevronRight,
} from '@mdi/js'

export default {
  name: 'ActionCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    avatarColor: {
      type: String,
      default: '#9b9b9b',
    },
    iconColor: {
      type: String,
      default: '#ffffff',
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      icons: {
        mdiChevronRight,
      },
    }
  },
}
